// @ts-nocheck

import v4 from 'uuid/v4';

type ObserverCallback = (next: unknown) => void;

type Observer = {
  uuid: string;
  callback: ObserverCallback;
};

class Subject {
  observers: Array<Observer> = [];

  subscribe(callback: ObserverCallback) {
    const uuid = v4();
    this.observers.push({ uuid, callback });
    return uuid;
  }

  next(value: unknown) {
    this.observers.forEach((observer) => {
      observer.callback(value);
    });
  }

  unsubscribe(uuid: string) {
    this.observers = this.observers.filter((observer) => observer.uuid !== uuid);
  }
}

export default Subject;
